import { createContext, useContext } from 'react';
import { tAgendaActionContext } from './Agenda.types';
import { initialState } from './AgendaAction.constants';

export const AgendaActionContext =
  createContext<tAgendaActionContext>(initialState);

export function useAgendaActionContext() {
  return useContext(AgendaActionContext);
}
